import React, { useEffect, useState } from "react";
import Check from "../../../assets/images/fi_check.svg";
import Arrow from "../../../assets/images/Arrow.svg";
import { useNavigate } from "react-router-dom";
import Modal2 from "../../../components/Modal2";
import Companies from "../../../components/Companies";
import { FaQuestionCircle } from "react-icons/fa";

function ToursCard({
  icon,
  title,
  gradientBackground,
  conicBackground,
  starIcon,
  setGetTourId,
  tours,
  handleTourClick,
  openCodeModal,
  selectedTours,
  index: groupIndex,
}) {
  const navigate = useNavigate();

  const handleCategoryClick = (category) => {
    setExpandedCategory((prevCategory) =>
      prevCategory === category ? null : category
    );
  };

  const formatTimeTo12Hour = (time24) => {
    const [hour, minute] = time24.split(":");
    const hours = parseInt(hour, 10);
    const suffix = hours >= 12 ? "PM" : "AM";
    const hours12 = hours % 12 || 12;
    return `${hours12}:${minute} ${suffix}`;
  };

  return (
    <>
      <div className="leap-relative  leap-flex md:leap-block md:leap-w-20 lg:leap-w-20 xl:leap-w-28 2xl:leap-w-44 leap-h-24 md:leap-h-44">
        <div
          style={{
            background:
              gradientBackground ||
              "linear-gradient(180deg, #8547F6 0%, #BC98FF 100%)",
          }}
          className="leap-absolute  leap-w-12 leap-h-12 sm:leap-w-16 sm:leap-h-16 md:leap-w-16 md:leap-h-16  leap-top-1/2 leap--translate-y-1/2 md:leap--translate-y-0   md:-leap-top-7 -leap-left-4 md:leap-left-1/2 leap-transform leap--translate-x-1/2  leap-p-2 leap-rounded-full leap-bg-[#842DFF29] leap-border leap-border-solid leap-border-[#CB97FF] leap-flex leap-justify-center leap-items-center"
        >
          <img
            src={icon}
            alt="Tours Icon"
            className="leap-w-6 leap-h-6 sm:leap-w-10 sm:leap-h-10 md:leap-w-12 md:leap-h-12 lg:leap-w-16 lg:leap-h-16"
            loading="lazy"
          />
        </div>

        {/* Main Box */}
        <div
          className="leap-flex  leap-w-28 sm:leap-w-44 md:leap-w-20 lg:leap-w-20 xl:leap-w-28    2xl:leap-w-44   leap-gap-1 leap-justify-center  leap-h-full leap-border leap-border-solid leap-border-[#99999966] leap-rounded-3xl"
          style={{
            background:
              conicBackground ||
              "linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)),conic-gradient(from 181.06deg at 50% 50%, rgba(71, 47, 140, 0.4) 0deg, rgba(0, 0, 0, 0) 172.66deg, #4a358268 281.25deg, rgba(71, 47, 140, 0.4) 360deg)",
          }}
        >
          <div className="leap-text-white  leap-my-auto  leap-text-xs md:leap-text-[8px] lg:leap-text-[10px] xl:leap-text-[12px]  2xl:leap-text-lg leap-uppercase leap-font-bold leap-text-center">
            {title}
          </div>
        </div>
        <div className="leap-flex leap-flex-col md:leap-block leap-w-28 sm:leap-w-44 md:leap-w-20 lg:leap-w-24 xl:leap-w-28 2xl:leap-w-44 leap-ml-12 md:leap-ml-0 leap-gap-0">
          {/* Tours List */}
          {tours?.map((tour, index) => {
            const uniqueId = `${groupIndex}-${index}`;
            // Unique ID for each tour
            const Id = {
              id: tour.id,
              // title: tour?.tour,
              title: `tour ${index + 1}`,
              time: tour?.time,
              category: title,
              categoryId: tour?.categoryId,
              date: tour?.date,
              endTime: tour?.endTime,
              eventId: tour?.eventId,
              eventItemId: tour?.eventItemId,
              startTime: tour?.startTime,
              tourId: tour?.tourId,
              customerId: tour?.customerId,
              booked: tour.booked,
            }; // Unique ID for each tour

            return (
              <div
                key={index}
                className="!leap-rounded-3xl leap-h-fit leap-mb-7  md:leap-my-6 leap-py-[1px] leap-w-full leap-w-fit leap-mx-auto md:leap-mx-0 leap-px-[1.1px]"
                style={{
                  background:
                    tour.booked ||
                    selectedTours.some(
                      (selected) =>
                        selected.id == tour.id &&
                        selected.categoryId == tour.categoryId
                    )
                      ? "linear-gradient(180deg, #EB3DF7 0%, #3B29AB 50%, #73FAFD 100%)"
                      : "#7300FF",
                }}
              >
                <button
                  onClick={() => handleTourClick(Id)} // Ensure this passes the correct index logic
                  className={` xl:leap-py-5 2xl:leap-py-3book  leap-relative leap-px-6 leap-flex leap-flex-col leap-gap-3 leap-justify-center leap-w-full leap-rounded-3xl  ${
                    tour.booked ||
                    selectedTours?.some(
                      (selected) =>
                        selected.id == tour.id &&
                        selected.categoryId == tour.categoryId
                    )
                      ? "leap-bg-[#515d7c] leap-text-black"
                      : "leap-bg-[#212053] leap-text-white"
                  }`}
                >
                  <div className="leap-text-[#73FAFD] leap-text-[11px] leap-text-center leap-w-full  xl:leap-text-sm 2xl:leap-text-base leap-font-semibold leap-uppercase">
                    {`tour ${index + 1}`}
                  </div>
                  <div className="leap-text-white leap-mx-auto leap-text-[10px] 2xl:leap-text-base leap-uppercase leap-font-bold">
                    {/* {tour?.time} */}
                    <p>{formatTimeTo12Hour(tour?.startTime)}</p>
                    <p className="leap-mx-1">TO</p>
                    <p> {formatTimeTo12Hour(tour?.endTime)}</p>
                  </div>
                  <div className=" leap-absolute leap-top-2 leap-right-3">
                    {tour.booked ||
                    selectedTours?.some(
                      (selected) =>
                        selected.id == tour.id &&
                        selected.categoryId == tour.categoryId
                    ) ? (
                      <FaQuestionCircle
                        className="w-14 h-14 text-white" // Tailwind classes for size (w-4 = 1rem) and color (text-white)
                        style={{ color: "#ffff" }}
                        onClick={(e) => {
                          setGetTourId(tour?.tourId);
                          openCodeModal();
                          e.stopPropagation();
                        }}
                      />
                    ) : (
                      <FaQuestionCircle
                        className="w-14 h-14 text-white" // Tailwind classes for size (w-4 = 1rem) and color (text-white)
                        style={{ color: "#ffff" }}
                        onClick={(e) => {
                          setGetTourId(tour?.tourId);
                          openCodeModal();
                          e.stopPropagation();
                        }}
                      />
                    )}
                  </div>
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default ToursCard;
